import React, { useCallback, useMemo } from 'react';
import useReactRouter from 'use-react-router';

import useFeature from 'hooks/useFeature';
import useWorkflow, { Step } from 'hooks/useWorkflow';

import { Container } from '@material-ui/core';

import CardSelectorWidget from 'features/CardSelector/CardSelectorWidget';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectCreditApplication,
  mergeApplication,
} from 'state/creditApplication';

const CardSelectorRoute: React.FC = ({ children }) => {
  const { isEnabled } = useFeature();
  const { location } = useReactRouter();
  const { pathFor, hasStep } = useWorkflow();

  const { selectedCardKey } = useSelector(selectCreditApplication);
  const dispatch = useDispatch();
  const handleSelect = useCallback(
    (selectedCardKey: string) => {
      dispatch(mergeApplication({ selectedCardKey }));
    },
    [dispatch],
  );

  const displayCardSelectorWidget = useMemo(() => {
    const isOnCardSelector =
      hasStep(Step.CARD_SELECTOR) &&
      location.pathname === pathFor(Step.CARD_SELECTOR);

    const isOnSecondCardSelector =
      hasStep(Step.SECOND_CARD_SELECTOR) &&
      location.pathname === pathFor(Step.SECOND_CARD_SELECTOR);

    return (
      isEnabled('cardSelector') && !isOnCardSelector && !isOnSecondCardSelector
    );
  }, [hasStep, isEnabled, location.pathname, pathFor]);

  return (
    <React.Fragment>
      {displayCardSelectorWidget && selectedCardKey ? (
        <Container maxWidth="xs">
          <CardSelectorWidget
            selectedCardKey={selectedCardKey}
            onSelect={handleSelect}
          />
        </Container>
      ) : null}
      {children}
    </React.Fragment>
  );
};

export default CardSelectorRoute;
